import React from "react"
import _ from "lodash"
import styled from "styled-components"
import Color from "color"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const LUM_THRESHOLD = 0.6

const PMButton = styled.button`
  height: 44px;
  width: 100%;
  font-size: 0.9em;
  border: none;
  padding: 0 16px;
  background-color: white;
  color: ${(props) => {
    if (props.color) {
      const bg = Color(props.color)
      if (bg.luminosity() > LUM_THRESHOLD) {
        return "#0084FF"
      }
      return props.color
    }
    return "#0084FF"
  }};
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:first-child {
    border-top: none;
  }

  &.nested-button {
    position: relative;
    .icon {
      font-size: 16px;
      position: absolute;
      top: 14px;
      right: 4px;
    }
  }

  >a {
    text-decoration: none;

    &:visited {
      color: ${(props) => {
    if (props.color) {
      const bg = Color(props.color)
      if (bg.luminosity() > LUM_THRESHOLD) {
        return "#0084FF"
      }
      return props.color
    }
    return "#0084FF"
  }};
    }
  }
`

const PMLinkButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  height: 44px;
  width: 100%;
  font-size: 0.9em;
  border: none;
  padding: 0 16px;
  background-color: white;
  color: ${(props) => {
    if (props.color) {
      const bg = Color(props.color)
      if (bg.luminosity() > LUM_THRESHOLD) {
        return "#0084FF"
      }
      return props.color
    }
    return "#0084FF"
  }};
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:first-child {
    border-top: none;
  }

  &:visited {
    color: ${(props) => {
    if (props.color) {
      const bg = Color(props.color)
      if (bg.luminosity() > LUM_THRESHOLD) {
        return "#0084FF"
      }
      return props.color
    }
    return "#0084FF"
  }};
    }

`

class MenuLayer extends React.Component {

  menuButton(key, button, color, fontSize) {
    const btnType = button.type
    switch (btnType) {
      case "postback":
        return (
          <PMButton
            key={key}
            color={color}
            className="postback-button"
            onClick={(e) => {
              e.stopPropagation()
              e.nativeEvent.stopImmediatePropagation()
              this.props.onSelectButton(button)
            }}
          >
            {button.title}
          </PMButton>
        )
      case "web_url":
        return (
          <PMLinkButton
            key={key}
            color={color}
            href={button.url}
            target="_blank" 
            rel="noreferrer"
            className="url-button"
          >
            {button.title}
          </PMLinkButton>
        )
      default: return null
    }
  }

  render() {
    const { items = [], color, fontSize } = this.props
    const isInLayer = this.props.path
    let menuTitle
    if (isInLayer) {
      const pathSplit = this.props.path.split(".")
      if (pathSplit[pathSplit.length - 1] === "buttons") {
        const newPathSplit = pathSplit.slice(0, pathSplit.length - 1)
        const path = newPathSplit.join(".")
        const targetButton = _.get(this.props.persistentMenu, `buttons.${path}`)
        if (targetButton) {
          menuTitle = targetButton.title
        } else {
          menuTitle = "Menu"
        }
      }
    }
    return (
      <div fontSize={fontSize} className="menu-container">
        {isInLayer ?
          <div className="header">
            <button
              className="header-button"
              onClick={this.props.onNavBack}
            >
              <FontAwesomeIcon className="icon" icon="angle-left" fixedWidth />
            </button>
            <div className="title">{isInLayer ? menuTitle : "Menu"}</div>
          </div>
          :
          null
        }
        <div className="menu-content">
          {items.map((button, i) =>
            this.menuButton(i.toString(), button, color, fontSize)
          )}
        </div>
      </div>
    )
  }
}

export default MenuLayer
